const lightBlue = require("@mui/material/colors/lightBlue");
const yellow = require("@mui/material/colors/yellow");

// Colors
const infoColor = lightBlue.default[500];
const warningColor = yellow.default[500];

// Spacing
const drawerWidth = 270;
const notificationCenterWidth = 300;
const MobileBreakpoint = 960;

export {
  infoColor,
  warningColor,
  drawerWidth,
  notificationCenterWidth,
  MobileBreakpoint,
};
